<template>
  <div
    v-for="item in items"
    :key="item.value"
  >
    <label
      class="select-circle__input-label typo-input"
      :for="item.value"
    >
      <input
        :id="item.value"
        v-model="radioValue"
        :checked="item.value === selectedItemValue"
        class="select-circle__radio-input"
        :name="name"
        type="radio"
        :value="item.value"
        @change="updateValue"
      >
      {{ item.label }}
    </label>
  </div>
</template>

<script setup>
import { ref } from 'vue';

defineProps({
  /** The items to be iterated over. Format: [{ value: 'value', label: 'label' }] */
  items: { type: Array, required: true },
  /** Model value to be updated when a button is selected */
  modelValue: { type: String, default: null },
  /** The input name */
  name: { type: String, required: true },
  /** Value of the item in the items array to be selected */
  selectedItemValue: { type: String, default: null }
});

const radioValue = ref(null);

const emit = defineEmits(['update:modelValue']);

function updateValue() {
  emit('update:modelValue', radioValue.value);
}

</script>

<style lang="scss" scoped>
@import "@/stylesheets/global";

.select-circle {
  &__radio-input {
    appearance: none;
    background-color: map-get($background-color, lightest);
    border: bu(0.15) solid currentColor;
    border-radius: 50%;
    color: map-get($foreground-color, light);
    cursor: pointer;
    display: grid;
    font: inherit;
    height: bu(2.5);
    margin: bu(0.1) 0;
    place-content: center;
    width: bu(2.5);

    &:before {
      content: '';
      width: bu(1.5);
      height: bu(1.5);
      border-radius: 50%;
      transform: scale(0);
      box-shadow: inset bu(1.5) bu(1.5) map-get($important-color, default);
    }

    &:checked {
      color: map-get($important-color, default);
      &:before {
        transform: scale(1);
      }
    }
  }

  &__input-label {
    display: flex;
    gap: bu(1);
    align-items: center;
    padding: bu(1) 0;
    font-size: bu(1.875);
    color: map-get($foreground-color, light);
    cursor: pointer;
  }
}

</style>
